import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, input, model, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { TranslocoPipe, TranslocoService } from "@jsverse/transloco";
import { SvgIconComponent } from "angular-svg-icon";
import { NgxMaskDirective } from "ngx-mask";
import { DirectusTranslationPipe } from "../../../../../../common/pipes/directus-translation.pipe";
import { GetDirectusImagePipe } from "../../../../../../common/pipes/get-directus-image.pipe";
import { ItemsHeaderBlock } from "../../../../../api/packbo/models/items-header-block";

@Component({
    selector: "packbo-landing-page",
    templateUrl: "./landing-page.template.html",
    styleUrls: ["./landing-page.style.css"],
    imports: [
        SvgIconComponent,
        DirectusTranslationPipe,
        GetDirectusImagePipe,
        TranslocoPipe,
        FormsModule,
        NgxMaskDirective
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LandingPageComponent {
    private readonly router = inject(Router);
    private readonly translocoService = inject(TranslocoService);

    public readonly headerBlock = input.required<ItemsHeaderBlock>();

    protected search = model<string>("");
    protected postalCode = model<string | null>(null);
    protected distance = signal<number | null>(null);
    protected distanceSearch = signal<string>("");

    protected readonly distances = (() => {
        const distances = [];
        for (let i = 5; i <= 200; i += 5) {
            distances.push({ value: i, label: `${i}km` });
        }
        return distances;
    })();

    protected selectDistance(distance: { value: number; label: string }): void {
        this.distance.set(distance.value);
        this.distanceSearch.set(distance.label);
    }

    protected searchSuppliers(): void {
        if (this.postalCode() && !this.distance()) {
            this.distance.set(50);
        }

        const search = this.search().trim();
        const postalCode = this.postalCode();
        const distance = this.distance();

        const languageCode = this.translocoService.getActiveLang();
        const directoryPathSegment = this.translocoService.translate("directoryPathSegment");
        const searchPathSegment = this.translocoService.translate("searchPathSegment");

        this.router.navigate([`/${languageCode}/${directoryPathSegment}/${searchPathSegment}`], {
            queryParams: postalCode
                ? { search: search, postalCode: postalCode, distance: distance }
                : { search: search }
        });
    }
}
